export enum RequestState {
	IDLE,
	Requested,
	Received,
}

export enum LanguagesShort {
	English = "en",
}

export enum TutorialSteps {
	Introduce,
	First,
}

export enum DirectionType {
	Asc = "ASC",
	Desc = "DESC",
}

export enum AnswerType {
	More = "more",
	Less = "less",
}

export enum ContestStatus {
	Draft = "draft",
	Scheduled = "scheduled",
	Active = "active",
	Complete = "complete",
	Cancelled = "cancelled",
}

export enum PlayerStats {
	JERSEY_NUMBER = "jersey_number",
	AGE = "age",
	GAMES_PLAYED = "games_played",
	WINS = "wins",
	ERA = "era",
	STRIKEOUTS = "strikeouts",
	HITS = "hits",
	BATTING_AVG = "batting_avg",
	RBIS = "rbis",
	HOME_RUNS = "home_runs",
	STOLEN_BASES = "stolen_bases",
	FASTEST_PITCH = "fastest_pitch",
	HIGHEST_EXIT_VELOCITY = "highest_exit_velocity",
}

export enum PlayerImageType {
	headshot = "headshot",
	actionShotImage = "actionShotImage",
	actionFullImage = "actionFullImage",
}

export enum ShareTarget {
	Facebook = "fb",
	Twitter = "tw",
	Native = "native",
}

export enum AdobeTrackStateActions {
	WelcomeModal = "welcome modal",
	HowToPlay = "how to play by the numbers",
	PlayerStats = "player stat",
	PlayerStatsCorrect = "player stat : correct",
	PlayerStatsIncorrect = "player stat : incorrect",
	ResultsModal = "results modal",
	Summary = "your summary",
	ErrorModal = "error modal",
	Menu = "menu",
}

export enum AdobeTrackActionActions {
	WelcomeModalExit = "welcome modal : exit click",
	WelcomeModalAction = "welcome modal : --X-- click", //play|how to play
	HowToPlayExit = "how to play by the numbers : exit click",
	HowToPlayStart = "how to play by the numbers : play now",
	SendAnswerClick = "player stat : --X-- button click", //more|less
	ResultModalAction = "results modal : --X-- click", // share|feedback
	ResultModalExit = "results modal : exit click",
	SummaryAction = "your summary : --X-- click",
	MenuAction = "menu : --X-- click", // how to play|leaderboards|feedback
}

export enum MenuSection {
	HowToPlay = "how to play",
	Leaderboards = "leaderboards",
	Feedback = "feedback",
}

export enum LeaderboardsType {
	Yesterday = "yesterday",
	Daily = "daily",
	AllTime = "all_time",
}

export enum ContextualProjects {
	BEAT_THE_STREAK = "beat_the_streak",
	BY_THE_NUMBER = "by_the_number",
	SPINBALL = "spinball",
	PLAYER_OF_THE_GAME = "player_of_the_game",
}
